import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import axios from "axios";
import { API, useApi } from "@/lib/api";

const MeCtx = createContext(null);

export function MeProvider({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState(null);

  const refresh = useCallback(async (showLoading = false) => {
    if (!isSignedIn) { setMe(null); setLoading(false); return; }
    if (showLoading === true) setLoading(true);
    try { const { data } = await api.get("/me"); setMe(data); setError(null); }
    catch (e) { setError(e?.response?.data?.detail || "Não foi possível carregar sua conta."); }
    setLoading(false);
  }, [isSignedIn, api]);

  useEffect(() => { if (isLoaded) { setLoading(true); refresh(); } }, [isLoaded, isSignedIn]); // eslint-disable-line
  useEffect(() => { axios.get(`${API}/public/meta`).then((r) => setMeta(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    if (!isSignedIn) return;
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [isSignedIn, refresh]);

  const [picked, setPicked] = useState(() => localStorage.getItem("zelobra_country"));
  const chooseCountry = useCallback((c) => {
    if (c) localStorage.setItem("zelobra_country", c); else localStorage.removeItem("zelobra_country");
    setPicked(c);
  }, []);
  const country = me?.country || picked || "BR";
  const needsCountry = !me?.country && !picked && !(isSignedIn && (!isLoaded || loading));

  return <MeCtx.Provider value={{ me, error, loading: !isLoaded || loading, refresh, meta, country, picked, chooseCountry, needsCountry }}>{children}</MeCtx.Provider>;
}

export const useMe = () => useContext(MeCtx);
